import React from 'react';

import { BaseIconProps } from '.';

export const Upload = ({ fill }: BaseIconProps) => (
  <g>
    <g>
      <g>
        <path
          fill={fill}
          d="M1023.7,298.2V130.7c0-71.9-58.3-130.2-130.2-130.2c0,0,0,0,0,0H186.5c-71.9,0-130.2,58.3-130.2,130.2
				c0,0,0,0,0,0v167.4h111.6V130.7c0-10.3,8.4-18.6,18.6-18.6h706.9c10.3,0,18.6,8.3,18.6,18.6v167.4H1023.7z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M595.8,1079.5V488.7l167.4,167.4l78.9-78.8L579.4,314.5c-21.8-21.8-57.1-21.8-78.9,0L237.9,577.2l78.9,78.8
				l167.4-167.4v590.8H595.8z"
        />
      </g>
    </g>
  </g>
);
